export interface Resident {
  id: number;
  firstName: string;
  firstNameKey?: string;
  lastName: string;
  lastNameKey?: string;
  email: string;
  phone: string;
  unitNumber: string;
  propertyId: number;
  moveInDate: Date;
  moveOutDate?: Date;
  isActive: boolean;
  emergencyContact?: EmergencyContact;
  preferences?: ResidentPreferences;
  createdDate: Date;
  updatedDate: Date;
  profilePicture?: string;
  dateOfBirth?: Date;
  occupation?: string;
  occupationKey?: string;
  employer?: string;
  employerKey?: string;
  vehicleInfo?: VehicleInfo[];
  familyMembers?: FamilyMember[];
}

export interface EmergencyContact {
  name: string;
  relationship: string;
  phone: string;
  email?: string;
  address?: string;
}

export interface ResidentPreferences {
  notifications: NotificationPreferences;
  language: string;
  timezone: string;
  theme: 'light' | 'dark' | 'auto';
  emailFrequency: 'immediate' | 'daily' | 'weekly';
}

export interface NotificationPreferences {
  email: boolean;
  sms: boolean;
  push: boolean;
  maintenance: boolean;
  announcements: boolean;
  bookings: boolean;
  invoices: boolean;
  emergencies: boolean;
}

export interface VehicleInfo {
  id: number;
  residentId: number;
  make: string;
  model: string;
  year: number;
  color: string;
  licensePlate: string;
  parkingSpot?: string;
  isActive: boolean;
}

export interface FamilyMember {
  id: number;
  residentId: number;
  firstName: string;
  lastName: string;
  relationship: string;
  dateOfBirth?: Date;
  phone?: string;
  email?: string;
  isEmergencyContact: boolean;
}

export interface ResidentActivity {
  id: number;
  residentId: number;
  activityType: ActivityType;
  description: string;
  timestamp: Date;
  metadata?: Record<string, any>;
}

export enum ActivityType {
  LOGIN = 'login',
  BOOKING_CREATED = 'booking_created',
  BOOKING_CANCELLED = 'booking_cancelled',
  REQUEST_SUBMITTED = 'request_submitted',
  PAYMENT_MADE = 'payment_made',
  PROFILE_UPDATED = 'profile_updated',
  OTHER = 'other',
}
